import ACTIONS from "../../constants/actions";

const initialState = {
	history  : {
		bets    : [],
		events  : [],
		leagues : []
	},
	fetching : true
};

export default function bet(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.BET.GET_HISTORY:
			return Object.assign({}, {history : action.data}, {fetching : false});

		case ACTIONS.BET.TOGGLE_FETCHING:
			return Object.assign({}, state, {fetching : !state.fetching});

		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/bet.js